import useSearchBranch from 'api/branch/useSearchBranch/useSearchBranch';
import useCardexList from 'api/cardex/useCardexList';
import useDownloadCardex from 'api/cardex/useDownloadCardex';
import useSearchZone from 'api/locationZone/useSearchZone/useSearchZone';
import useDeleteProduct from 'api/productsList/useDeleteProduct/useDeleteProduct';
import useProductsList from 'api/productsList/useProductsList/useProductsList';
import { CartexToolbar } from 'components/private/Cardex/CartexToolbar';
import DeleteModal from 'components/shared/DeleteModal/DeleteModal';
import ProductsListEditModal from 'components/shared/Modals/productsList/ProductsListEditModal/ProductsListEditModal';
import ProductsListInsertModal from 'components/shared/Modals/productsList/ProductsListInsertModal/ProductsListInsertModal';
import PageSpinner from 'components/shared/pageSpinner/PageSpinner';
import ApiPaginateTable from 'components/shared/Table/ApiPaginateTable';
import useCartexTableColumns from 'hooks/cardexList/useCardexTableColumns';
import { useCallback, useEffect, useRef, useState } from 'react';

// last search string
const lastSearch = null;

const Cardex = () => {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState('100');
  const [getCardexList, loading, cardexList, pageRef] = useCardexList();
  const tableRef = useRef(null);

  const [searchBranches, searchedBranchesLoading, searchedBranches] =
    useSearchBranch();
  const [searchZones, searchedZonesLoading, searchedZones] = useSearchZone();

  const [branchInputValue, setBranchInputValue] = useState();
  const [zoneInputValue, setZoneInputValue] = useState();

  const [selectedBranch, setSelectedBranch] = useState(null);
  const [selectedZone, setSelectedZone] = useState(null);

  useEffect(() => {
    searchBranches();
    searchZones();
  }, []);

  const [columnsData] = useCartexTableColumns(tableRef);

  function getPageData(pageNumber) {
    setPage(pageNumber);
    getCardexList({ page: pageNumber, count: pageSize, term: lastSearch });
  }

  return (
    <>
      <div>{pageRef.refTitle}</div>

      <ApiPaginateTable
        columns={columnsData}
        rowsData={cardexList[page]}
        rows={cardexList[page]}
        pageSize={pageSize}
        disableSelection
        isLoading={selectedBranch && selectedZone ? loading : false}
        setPageSize={val => setPageSize(val)}
        apiRef={tableRef}
        onPageChange={p => getPageData(p)}
        page={page}
        countPages={
          pageRef?.totalCount ? Math.ceil(pageRef.totalCount / pageSize) : 1
        }
        customToolbar={() => (
          <CartexToolbar
            addLable="نمایش کاردکس"
            searchBranches={searchBranches}
            searchZones={searchZones}
            setBranchInputValue={setBranchInputValue}
            setZoneInputValue={setZoneInputValue}
            selectedZone={selectedZone}
            setSelectedZone={setSelectedZone}
            searchedZones={searchedZones}
            zoneInputValue={zoneInputValue}
            selectedBranch={selectedBranch}
            setSelectedBranch={setSelectedBranch}
            searchedBranches={searchedBranches}
            branchInputValue={branchInputValue}
            submitCartex={({ zoneGuid, branchGuid }) => {
              if (zoneGuid && branchGuid) {
                getCardexList({ zoneGuid, branchGuid });
              }
            }}
          />
        )}
      />
    </>
  );
};

export default Cardex;
